export default "/static/assets/tree_gradient.30c22a39d4779eeebfba8e8d628452b4.svg";